// extracted by mini-css-extract-plugin
export default {"tile-shadow":"Tile_tile-shadow__UmMUk","tile-heading":"Tile_tile-heading__RiuCc"};